import React, { useEffect } from 'react';
import styled from 'styled-components';

import { FlexColumn, HeaderText } from '@make-software/cspr-design';
import { EventNotificationBanner } from '../components';

const StyledMainContainer = styled.main(({ theme }) => ({
  width: '100%',
  maxWidth: theme.maxWidth,
}));

export const Header = styled(HeaderText)(({ theme }) => ({
  paddingTop: 32,
  paddingBottom: 24,
}));

const Content = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    maxWidth: theme.maxWidth,
    padding: [
      '0px 16px 33px',
      '0px 32px 60px',
      '0px 56px 76px',
      '0px 0px 76px',
    ],
  })
);

export interface PageLayoutProps {
  children?: React.ReactNode;
  title?: string;
  renderHeader?: () => React.ReactNode;
}

export const PageLayout = React.memo((props: PageLayoutProps) => {
  const { children, renderHeader, title } = props;

  useEffect(() => {
    document.title = `${title} | CSPR.live`;
  }, [title]);

  return (
    <StyledMainContainer as="main" id="main-content" role="main" tabIndex={-1}>
      <Content>
        <EventNotificationBanner
          text={config.event_notification_text}
          linkText={config.event_notification_link_text}
          linkSource={config.event_notification_link_source}
          withPageTile
        />

        {renderHeader && <Header size={2}>{renderHeader()}</Header>}
        {children}
      </Content>
    </StyledMainContainer>
  );
});

export default PageLayout;
